<!--
  A window with a divider down the middle and the right-hand strip shaded.
  It means the record opens in a panel on the right. It is drawn in outline,
  and the part the record takes is shaded at 35% opacity, like the full page
  icon.
-->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.6"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    data-slot="icon"
    data-icon="side-peek"
  >
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <path d="M12 4v16" />
    <rect x="13" y="6.5" width="5.5" height="11" rx="1" fill="currentColor" fill-opacity="0.35" stroke="none" />
  </svg>
</template>
